<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="audit_template"
    :parentId="$route.params.id"
    :hasChapters="hasChapters"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/audit_template";
export default {
  data: () => ({
    modelName: "audit_template_version",
    label: "稽核公版版本",
    fields: model.fields.last_version.fields,
    hasChapters: true,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "版本內容",
              fields: ["locales"],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>